import * as Alfa from './alfa.module'
import * as Dabrabyt from './dabrabyt.module'
import * as Prior from './prior.module'

export const getUserFromBank = async (bank) => {
  if (bank === 'alfa') return Alfa.getUserProperties()
  if (bank === 'dabrabyt') return Dabrabyt.getUserProperties()
  if (bank === 'prior') return Prior.getUserProperties()
}